import AppLogo from "@/components/AppLogo";
import { ButtonOutline, ButtonSolid } from "@/components/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import illustration from "@/assets/img/illustrations/undraw_page_not_found_re_e9o6.svg";
const Error404 = () => {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <AppLogo className="mb-10 justify-center" />
        <p className="text-3xl font-semibold text-primary-600">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
          Page not found
        </h1>
        <div className="flex justify-center">
          <img src={illustration} className="h-60 w-60" />
        </div>
        <p className="mt-6 text-base leading-7 text-gray-600 dark:text-gray-500">
          Sorry, we couldn’t find the page you’re looking for.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <ButtonSolid label="Go back home" onClick={() => navigate("/")} />
          <ButtonSolid label="Contact Support" variant={"alternative"} />
        </div>
      </div>
    </div>
  );
};

export default Error404;
